var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-list-wrapper"},[_c('Banner'),_c('Jinyu'),_c('number-one')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }